/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "utils/url",
  "utils/lzma-url",
  "utils/browser"
  ], function(
    url,
    Lzma,
    browser
  ) {

    var LzmaHelper = {

      getRequestFromQueryURLParam: function (urlQueryString, limit) {
        var request = '';
        var validated = true;
        var decodedUrlQueryString = '';
        limit = limit || 0;

        try {
          var queryBody = Lzma.decompressUrlSafe(urlQueryString);
          var cleanUrl = url.removeQueryParams(browser.getURL()) + '?queryString=';
    
          if (limit > 0 && cleanUrl.length + urlQueryString.length > limit) {
            console.warn("The requested URL length exceeds the capacity limit for this server. Consider creating a shorter URL.");
            validated = false;
          }
    
          if (validated) {
            decodedUrlQueryString = browser.deparam(decodeURIComponent(queryBody.replace(/%2B/g, '%20')));
            request = decodedUrlQueryString.r;
          }
        } catch (error) {
          decodedUrlQueryString = decodeURIComponent(urlQueryString.replace(/%2B/g, '%20'));
          var queryString = browser.deparam(decodedUrlQueryString);
          request = queryString.r;
        }
    
        return {
          request: request,
          validated: validated
        };
      }
    };

    return LzmaHelper;
});
